import { logoutApi } from '../api/auth';
import { useSupportViewStore } from '../../host/store/supportViewStore';
import { clearAccessTokenLifetime } from './accessTokenLifetime';
import { clearClientAuthState } from './authSessionCoordinator';

/**
 * When true, bootstrap must not silently re-issue an access token from the refresh cookie
 * in the same document session (prevents invalidate → refresh → 401 loops).
 */
let skipSilentRefresh = false;

export function isSilentRefreshBlocked(): boolean {
  return skipSilentRefresh;
}

/** Call after a successful login so a new session can bootstrap normally. */
export function allowSilentRefresh(): void {
  skipSilentRefresh = false;
}

/** Drops client auth state and clears server auth cookies (refresh + CSRF). */
export async function invalidateAuthSession(): Promise<void> {
  skipSilentRefresh = true;
  clearAccessTokenLifetime();
  clearClientAuthState();
  useSupportViewStore.getState().clear();

  try {
    await logoutApi();
  } catch {
    // Session may already be invalid; still safe to continue.
  }
}
